import { Controller } from "@hotwired/stimulus"

// Keyboard support for daisyUI's focus-driven `.dropdown`.
//
// daisyUI opens the menu whenever focus is inside it, which is fine for
// mouse and Tab users but leaves no way to dismiss it without moving focus
// away (WCAG 1.4.13), and the trigger never reports its state. This adds:
//   - Escape: close the menu and return focus to the trigger
//   - Enter / Space on the trigger: reopen it after an Escape
//   - aria-expanded on the trigger, kept in sync with what's on screen
export default class extends Controller {
  static targets = ["trigger"]

  connect() {
    this.update(false)
  }

  close(event) {
    if (this.closed) return
    event.preventDefault()
    this.element.classList.add("dropdown-close")
    this.triggerTarget.focus()
    this.update(false)
  }

  open(event) {
    event.preventDefault()
    this.element.classList.remove("dropdown-close")
    this.update(true)
  }

  focusin() {
    this.update(!this.closed)
  }

  focusout(event) {
    if (this.element.contains(event.relatedTarget)) return
    // Focus has left entirely: reset so the next visit opens normally.
    this.element.classList.remove("dropdown-close")
    this.update(false)
  }

  update(expanded) {
    this.triggerTarget.setAttribute("aria-expanded", expanded)
  }

  get closed() {
    return this.element.classList.contains("dropdown-close")
  }
}
